import {
  CancelDialogActions,
  ImageCancelDialogLayout,
  CancelModal,
  CancelDialogMessageLayout,
} from '@Components/shared/dialogs/CancelDialog';
import { useUpdateMinesProviderConfig } from '@Modal/hooks/providers/useUpdateMinesProviderConfig';

export const UpdateMinesProviderConfigCancelModalDialog: React.FC = () => {
  const { handleCancelTakeMeBack, showCancelUpdateMinesProviderConfigForm } =
    useUpdateMinesProviderConfig();

  return (
    <>
      {showCancelUpdateMinesProviderConfigForm && (
        <CancelModal open={showCancelUpdateMinesProviderConfigForm}>
          <ImageCancelDialogLayout
            title="Cancel provider config?"
            actions={
              <CancelDialogActions
                onReject={() => handleCancelTakeMeBack('back')}
                onConfirm={() => handleCancelTakeMeBack('')}
              />
            }
          >
            <CancelDialogMessageLayout>
              You are about to delete all the changes you have made in provider config settings
            </CancelDialogMessageLayout>
          </ImageCancelDialogLayout>
        </CancelModal>
      )}
    </>
  );
};
